export default class MeuBoleto {
    constructor(resource) {
        this._resource = resource('meuboleto');
    }

    get(cnpj) {
        return this._resource
            .get({ cnpj: cnpj })
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

}